<app-loader *ngIf="isDisabled"></app-loader>
<div>
    <div class="row m-0">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-sm" (click)="reimbursementRequest()"
                [disabled]="isDisabled">
                <i class="bi bi-cash-coin" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Reimbursement Request':'Loading...'}}
            </button>
        </div>
    </div>
</div>

<div class="card border-radius-0 mt-1 p-0">
    <div class="card-header">
        <div class="card-title">
            Reimbursement Request History
        </div>
    </div>
    <div class="card-body">
        <form class="g-3" name="filterForm" (ngSubmit)="Validate(filterForm)" #filterForm="ngForm" novalidate>
            <div class="row pb-2">
                <div class="col-md-3">
                    <label for="ApprovalStatus" class="form-font-label">Status</label>
                    <select class="form-select" aria-label="ApprovalStatus" placeholder="Status" title="Status"
                        name="Status" data-live-search="true" [disabled]="Filter.IsWithdraw"
                        [(ngModel)]="Filter.ApprovalStatus" (change)="Clear()" #ApprovalStatus="ngModel" required>
                        @for (status of common.ReimbursementStatus; track status.Value; let i = $index) {
                        <option [value]="status.Value">
                            <div class="row">
                                <div class="col">{{status.Name}}</div>
                            </div>
                        </option>
                        }
                    </select>
                    <div class="invalid-feedback">
                        Please select status!
                    </div>
                </div>
                <div class="col-md-2 px-1"><br>
                    <div class="form-check ms-3">
                        <input type="checkbox" class="form-check-input" id="checkbox" [(ngModel)]="Filter.IsCheckedbox"
                            name="chf" [disabled]="Filter.IsWithdraw" (change)="Clear()">
                        <label class="form-check-label" for="checkbox">Include Date</label>
                    </div>
                </div>
                <div class="col-md-3 px-1" *ngIf="Filter.IsCheckedbox">
                    <label class="Label">Month and Year</label>
                    <ngb-datepicker #dp [(ngModel)]="selectedMonth" class="month-year"
                        (navigate)="selectedMonth= $event.next;onNavigate();Clear()" [disabled]="Filter.IsWithdraw"
                        name="dateselect" style="width: 80%;"></ngb-datepicker>
                </div>
                <div class="col-md-2" style="align-content: center;font-weight: 500;font-size: 15px;">
                    <span class="Label" style="margin-left: 3%;">
                        <input type="checkbox" name="admincharg" [(ngModel)]="Filter.IsWithdraw" ngbCheckbox
                            (change)="Clear()" />
                        Withdraw Only
                    </span>
                </div>
                <div class="col-md-auto mt-4">
                    <button type="submit" class="btn btn-primary btn-sm" [disabled]="isDisabled">
                        <i class="bi bi-search" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Search':'Loading...'}}
                    </button>
                </div>
            </div>
        </form>
        <div>
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered mt-1">
                <thead class="table-light">
                    <tr>
                        <th scope="col" style="width: 5px;">#</th>
                        <th style="width: 5px;" *ngIf="!Filter.IsWithdraw">View</th>
                        <th style="width: 5px;" *ngIf="!Filter.IsWithdraw">Withdraw</th>
                        <th style="width: 600px;" [ngClass]="{'colHide': common.ToLowerCase(user.EmpType) == 'back'}">
                            Client Location</th>
                        <th style="width: 50px;">Designation</th>
                        <th style="width: 50px;">RequestDate</th>
                        <th style="width: 50px;">Bill Amount</th>
                        <th style="width: 50px;">Claimed Amount</th>
                        <th style="width: 10px;">Outstanding Amount</th>
                        <th style="width: 50px;">Month Year</th>
                        <th style="width: 10px;">Reimbursement Type</th>
                        <th style="width: 50px;">Remark</th>
                        <th style="width: 50px;">Is Reimbursed</th>
                        <th style="width: 50px;">Reimbursed Date</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width: 5px;" *ngIf="!Filter.IsWithdraw">
                            <div style="width: 70px;"><button type="button" class="btn btn-outline-primary btn-sm"
                                (click)="reimbursementView(TableData['ESS_ReimbursementRequestId'])"><i
                                        class="bi bi-info-square me-1"></i>View</button></div>
                        </td>
                        <td style="width: 5px;" *ngIf="!Filter.IsWithdraw">
                            <div style="width: 110px;"
                                *ngIf="common.ToLowerCase(TableData['ApprovalStatus']) == 'pending'"><button
                                    type="button" class="btn btn-outline-primary btn-sm"
                                    (click)="WithdrawReimbursement(i)"><i
                                        class="bi bi-x-circle me-1"></i>Withdraw</button></div>
                        </td>
                        <td style="width: 600px;" [ngClass]="{'colHide': common.ToLowerCase(user.EmpType) == 'back'}">
                            <div style="width: 200px;">{{TableData['ClientLocation']}}</div>
                        </td>
                        <td style="width: 50px;">{{TableData['DesignationName']}}</td>
                        <td style="width: 50px;">{{TableData['RequestDate'] }}</td>
                        <td style="width: 50px;">{{TableData['BillAmount'] }}</td>
                        <td style="width: 50px;">{{TableData['ClaimedAmount'] }}</td>
                        <td style="width: 10px;">{{TableData['OutstandingAmount']}}</td>
                        <td style="width: 50px;">{{TableData['MonthYear']}}</td>
                        <td style="width: 10px;">{{TableData['ReimbursementType']}}</td>
                        <td style="width: 50px;">{{TableData['Remark']}}</td>
                        <td style="width: 50px;">{{TableData['IsReimbursed'] == true ? 'Yes' : 'No'}}</td>
                        <td style="width: 50px;">{{TableData['ReimbursementDate']}}</td>
                        <td><span class="badge"
                                [ngClass]="{'success':common.ToLowerCase(TableData['ApprovalStatus']) == 'approved', 'warning':common.ToLowerCase(TableData['ApprovalStatus']) == 'pending','danger':common.ToLowerCase(TableData['ApprovalStatus']) == 'rejected'}">{{TableData['ApprovalStatus']}}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>